export default "__VITE_ASSET__BFMTyjx4__"